<rb-form-date-input
  name="dateTime"
  [label]="'Timestamp (' + timezone + ')'"
  [ngModel]="datetime"
  (ngModelChange)="onChange($event)"
  [options]="{
    enableTime: enableTime,
    allowInput: true,
    minuteIncrement: step,
    minDate: minDate,
    maxDate: maxDate,
    disableMobile: true,
  }"
  required
  [disabled]="disabled"
>
</rb-form-date-input>
